export const NATIVE_DEVICE_TYPE = {
  IOS: 'ios',
  ANDROID: 'android'
} as const;

export const NATIVE_POST_MESSAGE_TYPE = {
  ROUTE: 'route'
} as const;
